import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountAddressesQuery } from 'restful/accounts/queries/useAccountAddresses';
import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import { createAddress } from 'services/api/restful/generated/accounts/accounts';
import type {
  Address,
  AddressUpsert,
} from 'services/api/restful/generated/nofomoRestApi.schemas';

export const useCreateAddress = () => {
  const queryClient = useQueryClient();

  const { isPending, isPaused, isError, mutate } = useMutation<
    Address,
    RestApiError,
    AddressUpsert
  >({
    mutationFn: async (input) => {
      const { data } = await restCall(() => createAddress(input));
      return data;
    },
    onSuccess: (address) => {
      queryClient.invalidateQueries({
        queryKey: accountAddressesQuery.queryKey,
      });
      queryClient.setQueryData(accountAddressesQuery.queryKey, (oldData) => {
        if (!!oldData) {
          return {
            addresses: [...oldData.addresses, address],
          };
        }
      });
    },
  });

  return {
    createAddress: mutate,
    isLoading: isPending && !isPaused,
    isError,
  };
};
